import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../../services/api';
import AdminLogoHeader from '../../components/admin/AdminLogoHeader';
import PendingOnboardingTable from '../../components/admin/PendingOnboardingTable';
import { AuthContext } from '../../context/AuthContext';
import { getRole } from '../../services/authStorage';

const ComplianceApprovals = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const role = user?.role || getRole();
  const canManualOnboard = role === 'ops' || role === 'admin' || role === 'compliance';
  const canCreateStaff = role === 'admin';

  const loadPending = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const data = await api.adminListPendingUsers();
      setRows(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('pending users', err);
      setError(err.message || 'Unable to load pending onboardings.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPending();
  }, [loadPending]);

  return (
    <div className="min-h-screen bg-slate-50">
      <AdminLogoHeader />
      <div className="max-w-7xl mx-auto p-6">
        <div className="mb-6 flex flex-col gap-3 rounded-2xl border border-slate-100 bg-white px-6 py-4 shadow-sm md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-lg font-semibold text-slate-900">Compliance approvals</h1>
            <p className="text-sm text-slate-500">
              Review onboarding submissions and manually invite new applicants when needed.
            </p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row">
            {canManualOnboard ? (
              <button
                type="button"
                onClick={() => navigate("/admin/compliance/manual-entry")}
                className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700"
              >
                Manual onboarding
              </button>
            ) : null}
            {canCreateStaff ? (
              <button
                type="button"
                onClick={() => navigate("/admin/compliance/staff")}
                className="rounded-lg border border-emerald-600 px-4 py-2 text-sm font-semibold text-emerald-700 hover:bg-emerald-50"
              >
                Create staff account
              </button>
            ) : null}
          </div>
        </div>
        <PendingOnboardingTable
          rows={rows}
          loading={loading}
          error={error}
          onChange={(updater) => {
            setRows((prev) => {
              const next = typeof updater === 'function' ? updater(prev) : updater;
              return Array.isArray(next) ? next : [];
            });
            loadPending();
          }}
          onPreview={(row) => navigate(`/admin/compliance/${row.id}`)}
        />
      </div>
    </div>
  );
};

export default ComplianceApprovals;
